// extracted by mini-css-extract-plugin
export default {"description":"CoreMetricsPage_description__y5P02","cards":"CoreMetricsPage_cards__4Irji"};